import { computed } from 'vue'
import { useRoute } from 'vue-router'

export function useSiteSlug() {
    const route = useRoute('/(app)/[org]/')
    return computed(() => route.params.org)
}